import React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { Flex, Tag } from "@jsq/ds/core";
import { ImpactedGPRow } from "./types";

const GroupInnerRenderer: React.FC<ICellRendererParams> = (params) => {
  const value: string = params.value as string;
  const data = params.data as ImpactedGPRow | undefined;

  type Ctx = { drawerCaseId?: number };
  const ctx = (params.context || {}) as Ctx;
  const drawerCaseId = ctx.drawerCaseId;

  const showOriginChip =
    typeof drawerCaseId === "number" &&
    typeof data?.case?.id === "number" &&
    // match either the aggregated parent case id or the first detail position case id
    (data?.case?.id === drawerCaseId ||
      data?.details?.some((d) => d.positionName.id === drawerCaseId));

  return (
    <Flex alignItems="center" gap={20}>
      <span>{value}</span>
      {showOriginChip && <Tag variant="neutral">Originating case</Tag>}
    </Flex>
  );
};

export default GroupInnerRenderer;
